import React from 'react';

type StepCardSize = 'default' | 'medium' | 'full';

const StepCard = ({
  children,
  testId,
  className,
  size = 'default'
}: {
  children: React.ReactNode;
  testId?: string;
  className?: string;
  size?: StepCardSize;
}) => {
  const getWidthClass = (cardSize: StepCardSize): string => {
    switch (cardSize) {
      case 'medium':
        return 'w-140';
      case 'full':
        return 'w-full';
      case 'default':
      default:
        return 'w-84/100';
    }
  };

  return (
    <div
      className={`${getWidthClass(
        size
      )} bg-white flex flex-col px-6 py-4 font-body mb-mtcm rounded-lg shadow-sm-card border ${className ||
        ''}`}
      data-testid={testId || 'step-card-integrations'}
    >
      {children}
    </div>
  );
};

export default StepCard;
